import { ActionTask, WebApiResponseBase } from "@shared/classes/general";

export class FinishTask {
  static readonly type = '[General] Finish an on-going task';
  constructor(public taskId: string, public taskResponse: any) { }
}

export class FailTask {
  static readonly type = '[General] Fail an on-going task';
  constructor(public taskId: string, public error: WebApiResponseBase) { }
}

export class MarkTaskTimeout {
  static readonly type = '[General] Mark an on-going task into Timeout status';
  constructor(public taskId: string) { }
}

export class ResumeTask {
  static readonly type = '[General] Resume a Timed-out task';
  constructor(public taskId: string) { }
}

export class RegisterTask {
  static readonly type = '[General] Register new task into TaskManager';
  constructor(public task: ActionTask) { }
}

export class TerminateTask {
  static readonly type = '[General] Terminate a completed task by removing it from the Task Manager';
  constructor(public taskName: string, public taskId?: string) { }
}
